/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import securityImage from '../images/security.png';

const SensitiveDataPlug = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.paper',
        paddingBottom: '60px',
        minHeight: '450px',
      }}
    >
      <Box component="img" src={securityImage} alt="SensitiveData" sx={{ height: '180px' }} />
    </Box>
  );
};

export default SensitiveDataPlug;
